import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		fontSize: 13,
		color: THEME.colors.text.main,
		flexWrap: 'wrap',
	},
	description: {
		lineHeight: 1.4,
	},
	bold: {
		fontWeight: 600,
	},
});
